var map = {
	"./10-itens-checar-antes-de-viajar-no-feriado.md": 2719,
	"./7-habitos-aumentam-consumo-combustivel-2026.md": 4049,
	"./aditivo-de-combustivel-na-bomba-ou-frasco.md": 1350,
	"./alinhamento-balanceamento-a-cada-10-mil-km-2026.md": 8126,
	"./ar-condicionado-vs-janelas-abertas-o-que-gasta-menos.md": 6798,
	"./bateria-do-carro-quanto-tempo-dura-e-como-prolongar.md": 704,
	"./calibragem-de-pneus-quanto-voce-economiza-por-mes.md": 550,
	"./carro-eletrico-carregamento-rapido-mito-brasil-2026.md": 2963,
	"./carros-flex-mais-economicos-2026-ranking-inmetro.md": 2624,
	"./categorias-e-adicoes-da-cnh-brasileira-o-que-cada-categoria-permite.md": 1885,
	"./cilada-do-lucro-liquido-motoristas-app.md": 6062,
	"./cnh-sem-autoescola-nova-regra-2026.md": 9798,
	"./combustivel-adulterado-como-identificar-e-evitar-prejuizo.md": 1674,
	"./como-calcular-custo-km.md": 9194,
	"./como-entender-codigos-de-pneus-e-economizar.md": 5431,
	"./como-recorrer-multa-de-transito-em-2026.md": 9230,
	"./como-usar-calculadora-gas2-etanol-ou-gasolina-2026.md": 3167,
	"./cuidados-com-arrefecimento-do-veiculo.md": 8977,
	"./dicas-motoristas-app-rodovias-br-040-feriado-2026.md": 4026,
	"./direcao-economica-tecnicas-motoristas-app.md": 6897,
	"./economia-combustivel-moto-entregadores-ifood-2026.md": 6924,
	"./economia-em-viagens-longas-checklist-antes-de-pegar-a-estrada.md": 2023,
	"./economizar-gasolina.md": 4006,
	"./etanol-ou-gasolina-2026.md": 9834,
	"./etanol-vs-gasolina-principais-cidades-mg-2026.md": 3237,
	"./filtro-ar-combustivel-impacto-consumo-2026.md": 4910,
	"./freios-pastilhas-discos-quando-trocar-custo-2026.md": 8435,
	"./gasolina-e35-o-que-muda-no-bolso-e-no-motor.md": 358,
	"./guia-pratico-comprar-carro-usado-sem-ciladas-2026.md": 2942,
	"./manutencao-ar-condicionado-automotivo.md": 2334,
	"./manutencao-barata-pecas-originais-vs-paralelas-2026.md": 9669,
	"./melhores-carros-usados-brasil-como-escolher.md": 4821,
	"./motos-economicas-ifood-2026-ranking.md": 3034,
	"./o-que-e-tacografo-para-que-serve-como-ler.md": 2450,
	"./o-que-fazer-em-acidente-de-transito-guia-de-seguros-e-dpvat-2026.md": 1807,
	"./planilha-ganhos-gastos-motorista-app-modelo-gas2-2026.md": 405,
	"./pneus-economicos-vs-pneus-comuns-vale-a-pena-trocar-2026.md": 9462,
	"./pontos-na-cnh-multas-ear-como-funciona.md": 2394,
	"./por-que-dirigir-de-verdade-e-diferente-dos-video-games.md": 2436,
	"./precos-combustivel-hoje-etanol-ou-gasolina-2026.md": 264,
	"./preparando-carro-para-o-verao-2026-checklist.md": 9553,
	"./primeiro-carro-o-que-saber-antes-de-comprar.md": 3024,
	"./problemas-comuns-no-carro-sinais-como-resolver-rapido.md": 6373,
	"./quanto-ar-condicionado-aumenta-consumo-2026.md": 8489,
	"./quanto-brasileiro-paga-imposto-combustivel-2026.md": 944,
	"./quanto-custa-rodar-100-km-sandero-logan-flex-2026.md": 9233,
	"./seu-carro-foi-leiloado-nos-ultimos-5-anos-voce-pode-ter-dinheiro-a-receber.md": 3160,
	"./sinais-correia-dentada-para-romper.md": 7996,
	"./troca-de-oleo-sintetico-ou-mineral-qual-dura-mais.md": 9326,
	"./uber-vs-99-lucro-liquido-2026.md": 8938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7995;